import { listItemEstablecimiento, totalEstablecimiento, destroy } from '../js/cart-sessionstorage/cart-sessionstorage.js';
export default {
  methods: {
    crearMensaje() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      let establecimiento = JSON.parse(localStorage.getItem('_establecimiento'));
      var idEstablecimientoParam = app.view.main.router.currentRoute.params.idEstablecimiento;
      let formData = app.form.convertToData('#form-pedido');
      let nombre = formData.nombre;
      let listaItems = "";
      let listaItemsAux = "";
      let tipoEnvio = $('input[name="demo-radio-start"]:checked').val();
      let direccion = $('input[name="direccion"]').val().trim();
      let datoAdicional = $('textarea[name="dato-adicional"]').val();
      var mesa = $('input[type=text][name=tipo_mesa]').val().trim();
      let mensaje = "Hola!%0aMi nombre es " + formData.nombre + "%0a%0aQuisiera pedir:%0a";
      let itemsArr = listItemEstablecimiento(idEstablecimientoParam);

      for (let i = 0; i < itemsArr.length; i++) {
        const item = itemsArr[i];

        if (item.mostrar_precio) {
          if (tipoEnvio == 'Estoy en el lugar') {
            listaItemsAux = item.quantity + " x " + item.name + " [" + item.categoria + "] - $ " + item.price + " *($ " + (item.quantity * item.price).toFixed(2) + ")*" + "%0a";
          } else if (tipoEnvio == 'Takeaway') {
            listaItemsAux = item.quantity + " x " + item.name + " [" + item.categoria + "] - $ " + item.price_takeaway + " *($ " + (item.quantity * item.price_takeaway).toFixed(2) + ")*" + "%0a";
          } else if (tipoEnvio == 'Delivery') {
            listaItemsAux = item.quantity + " x " + item.name + " [" + item.categoria + "] - $ " + item.price_delivery + " *($ " + (item.quantity * item.price_delivery).toFixed(2) + ")*" + "%0a";
          } else if (tipoEnvio == 'Personalizado') {
            listaItemsAux = item.quantity + " x " + item.name + " [" + item.categoria + "] - $ " + item.price_personalizado + " *($ " + (item.quantity * item.price_personalizado).toFixed(2) + ")*" + "%0a";
          }
        } else {
          if (tipoEnvio == 'Estoy en el lugar') {
            listaItemsAux = item.quantity + " x " + item.name + " [" + item.categoria + "]" + "%0a";
          } else if (tipoEnvio == 'Takeaway') {
            listaItemsAux = item.quantity + " x " + item.name + " [" + item.categoria + "]" + "%0a";
          } else if (tipoEnvio == 'Delivery') {
            listaItemsAux = item.quantity + " x " + item.name + " [" + item.categoria + "]" + "%0a";
          } else if (tipoEnvio == 'Personalizado') {
            listaItemsAux = item.quantity + " x " + item.name + " [" + item.categoria + "]" + "%0a";
          }
        }

        listaItems += listaItemsAux;
      }

      mensaje += listaItems;

      if (establecimiento.configuracion.mostrar_precio_total) {
        mensaje += "%0aTotal: *$ " + totalEstablecimiento(idEstablecimientoParam).toFixed(2) + "*%0a";
      }

      if (tipoEnvio != "Personalizado") {
        mensaje += "%0aEnvío: *" + tipoEnvio + "*%0a";
      } else {
        mensaje += "%0aEnvío: *" + establecimiento.configuracion.nombre_envio_personalizado + "*%0a";
      } // if (sessionStorage.getItem('_mesa')) {
      //     let mesa = sessionStorage.getItem('_mesa');
      //     mensaje += "%0a" + establecimiento.configuracion.tipo_mesa + ": *" + mesa + "*%0a";
      // }


      if (tipoEnvio == "Delivery") {
        mensaje += "%0aDirección: *" + direccion + "*%0a";
      } else if (tipoEnvio == "Estoy en el lugar") {
        mensaje += "%0a" + establecimiento.configuracion.tipo_mesa + ": *" + mesa + "*%0a";
      } else if (tipoEnvio == "Personalizado") {
        mensaje += "%0a" + establecimiento.configuracion.nombre_envio_personalizado + ": *" + mesa + "*%0a";
      }

      if (datoAdicional.length > 0) {
        mensaje += "%0aObservación: " + datoAdicional + "%0a";
      }

      mensaje += "%0a¡Gracias!";
      console.log(mensaje);
      self.enviarMensaje(mensaje);
      self.logPedido(nombre, mesa, tipoEnvio, datoAdicional);
    },

    enviarMensaje(mensaje) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      let idEstablecimientoParam = app.view.main.router.currentRoute.params.idEstablecimiento;
      let idMesaParam = app.view.main.router.currentRoute.params.idMesa;

      if (localStorage.getItem('_establecimiento') !== null) {
        let establecimiento = JSON.parse(localStorage.getItem('_establecimiento'));

        if (establecimiento.whatsapp) {
          let urlWhatsapp = "https://api.whatsapp.com/send?phone=" + establecimiento.whatsapp + "&text=" + mensaje;
          $('.realizar-pedido-button').attr('href', urlWhatsapp);
          destroy();
          app.views.main.router.navigate({
            name: 'principal-menu',
            params: {
              idEstablecimiento: idEstablecimientoParam,
              idMesa: idMesaParam
            }
          });
        }
      }
    },

    validarCampos() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var nombre = $('input[type=text][name=nombre]').val().trim();
      var tipoEnvio = $('input[name="demo-radio-start"]:checked').val();
      var mesa = $('input[type=text][name=tipo_mesa]').val().trim();
      var direccion = $('input[type=text][name=direccion]').val().trim();

      if (nombre.length < 3) {
        $('.realizar-pedido-button').addClass('disabled');
        return false;
      }

      if (!tipoEnvio) {
        $('.realizar-pedido-button').addClass('disabled');
        return false;
      }

      if (tipoEnvio == "Delivery" && direccion.length < 3) {
        $('.realizar-pedido-button').addClass('disabled');
        return false;
      }

      if (tipoEnvio == "Estoy en el lugar" && mesa.length < 1) {
        $('.realizar-pedido-button').addClass('disabled');
        return false;
      }

      if (tipoEnvio == "Personalizado" && mesa.length < 1) {
        $('.realizar-pedido-button').addClass('disabled');
        return false;
      }

      $('.realizar-pedido-button').removeClass('disabled');
      return true;
    },

    logPedido(nombre, mesa, tipoEnvio, datoAdicional) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var idEstablecimientoParam = app.view.main.router.currentRoute.params.idEstablecimiento;
      let url = window.global.url + "carrito/log/confirm-order";
      let pedido = {
        id_establecimiento: idEstablecimientoParam,
        nombre: nombre,
        tipo_envio: tipoEnvio
      };
      app.preloader.show();
      app.request.postJSON(url, pedido, function (data) {});
      app.preloader.hide();
    }

  },
  on: {
    pageBeforeIn() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      let establecimiento = JSON.parse(localStorage.getItem('_establecimiento'));
      let tipoEnvio = sessionStorage.getItem('_tipoenvio');

      if (tipoEnvio == 'en-el-lugar' && sessionStorage.getItem('_mesa') !== '') {
        $('.tipo_mesa-item-label').text(establecimiento.configuracion.tipo_mesa);
        $('input[type=text][name=tipo_mesa]').attr('placeholder', establecimiento.configuracion.tipo_mesa);
        let mesa = sessionStorage.getItem('_mesa');
        $('.li-tipo-mesa').removeClass('display-none');
        $("input[type=text][name=tipo_mesa]").val(mesa);
        $('input[name="demo-radio-start"][value="Estoy en el lugar"]').attr("checked", "checked");
      }

      if (tipoEnvio == 'en-el-lugar' && establecimiento.configuracion.pedido_en_el_lugar) {
        $('.li-pedido-en-el-lugar').removeClass('display-none');

        if (tipoEnvio == 'en-el-lugar') {
          $('input[name="demo-radio-start"][value="Estoy en el lugar"]').attr("checked", "checked");
          $('.li-tipo-mesa').removeClass('display-none');

          if (establecimiento.configuracion.mensaje_en_el_lugar) {
            $('.li-mensaje-tipo-envio').removeClass('display-none');
            $('.li-mensaje-tipo-envio .item-inner').html(establecimiento.configuracion.mensaje_en_el_lugar);
          }
        }
      }

      if (tipoEnvio == 'takeaway' && establecimiento.configuracion.takeaway) {
        $('.li-takeaway').removeClass('display-none');

        if (tipoEnvio == 'takeaway') {
          $('input[name="demo-radio-start"][value="Takeaway"]').attr("checked", "checked");

          if (establecimiento.configuracion.mensaje_takeaway) {
            $('.li-mensaje-tipo-envio').removeClass('display-none');
            $('.li-mensaje-tipo-envio .item-inner').html(establecimiento.configuracion.mensaje_takeaway);
          }
        }
      }

      if (tipoEnvio == 'delivery' && establecimiento.configuracion.delivery) {
        $('.li-delivery').removeClass('display-none');

        if (tipoEnvio == 'delivery') {
          $('input[name="demo-radio-start"][value="Delivery"]').attr("checked", "checked");
          $('.li-direccion').removeClass('display-none');

          if (establecimiento.configuracion.mensaje_delivery) {
            $('.li-mensaje-tipo-envio').removeClass('display-none');
            $('.li-mensaje-tipo-envio .item-inner').html(establecimiento.configuracion.mensaje_delivery);
          }
        }
      }

      if (tipoEnvio == 'personalizado' && establecimiento.configuracion.envio_personalizado) {
        $('input[name="demo-radio-start"][value="Personalizado"]').attr("checked", "checked");
        $('.li-envio-personalizado .item-title').text(establecimiento.configuracion.nombre_envio_personalizado);
        $('input[type=text][name=tipo_mesa]').attr('placeholder', establecimiento.configuracion.nombre_envio_personalizado);
        $('.li-envio-personalizado').removeClass('display-none');
        $('.li-tipo-mesa').removeClass('display-none');

        if (establecimiento.configuracion.mensaje_envio_personalizado) {
          $('.li-mensaje-tipo-envio').removeClass('display-none');
          $('.li-mensaje-tipo-envio .item-inner').html(establecimiento.configuracion.mensaje_envio_personalizado);
        }
      }
    },

    pageInit() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      $("input[type=text][name=nombre], input[type=text][name=direccion], input[type=text][name=tipo_mesa]").on('input', function () {
        self.validarCampos();
      });
      $('input[name="demo-radio-start"]').on('change', function (ev) {
        // console.log($(ev.currentTarget).val());
        if ($(ev.currentTarget).val() == "Delivery") {
          $('.li-direccion').removeClass('display-none');
        } else {
          $('.li-direccion').addClass('display-none');
        }

        if ($(ev.currentTarget).val() == "Estoy en el lugar") {
          $('.li-tipo-mesa').removeClass('display-none');
        } else {
          $('.li-tipo-mesa').addClass('display-none');
        }

        self.validarCampos();
      });
      $('.realizar-pedido-button').on('click', function () {
        self.crearMensaje();
      });
    }

  },
  id: '42fa27d8da',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=pedido-form><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Atrás</span></a></div><div class=title>Confirmar pedido</div><div class=right></div></div></div><!-- Fixed Toolbar --><div class="toolbar toolbar-bottom bg-color-green"><div class=toolbar-inner><span></span> <a target=_blank class="link external button realizar-pedido-button text-color-white disabled">Realizar pedido Whatsapp</a> <span></span></div></div><div class=page-content><div class="row justify-content-center"><div class="col-100 medium-100 large-50"><div class=block><h3>Completa los datos para confirmar tu pedido en Whatsapp</h3></div><form class="list no-hairlines" id=form-pedido><ul><li><div class="item-content item-input"><div class=item-inner><div class="item-title item-label">Nombre y apellido</div><div class=item-input-wrap><input type=text name=nombre placeholder="Nombre y apellido" maxlength=35 required validate></div></div></div></li><li class=margin-top><div class=block-header>Tipo de envío</div></li><li class="li-pedido-en-el-lugar display-none"><label class="item-radio item-radio-icon-start item-content"><input type=radio name=demo-radio-start value="Estoy en el lugar"> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Estoy en el lugar</div></div></label></li><li class="li-takeaway display-none"><label class="item-radio item-radio-icon-start item-content"><input type=radio name=demo-radio-start value=Takeaway> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Take away (para llevar)</div></div></label></li><li class="li-delivery display-none"><label class="item-radio item-radio-icon-start item-content"><input type=radio name=demo-radio-start value=Delivery> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Delivery</div></div></label></li><li class="li-envio-personalizado display-none"><label class="item-radio item-radio-icon-start item-content"><input type=radio name=demo-radio-start value=Personalizado> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title></div></div></label></li><li class="li-mensaje-tipo-envio display-none"><div class=item-content><div class=item-inner></div></div></li><li class="li-tipo-mesa display-none"><div class="item-content item-input"><div class=item-inner><div class="item-title item-label tipo_mesa-item-label"></div><div class=item-input-wrap><input type=text name=tipo_mesa maxlength=45 required validate></div></div></div></li><li class="li-direccion display-none"><div class="item-content item-input"><div class=item-inner><div class="item-title item-label">Dirección</div><div class=item-input-wrap><input type=text name=direccion placeholder="Escribí tu dirección" maxlength=100 required validate></div></div></div></li><li class=margin-top><div class="item-content item-input"><div class=item-inner><div class="item-title item-label">Comentario</div><div class=item-input-wrap><textarea name=dato-adicional placeholder="Comentario (opcional)"></textarea></div></div></div></li></ul></form></div></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};